/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Accountingcategory_Creditor9Inputs */



/**

* @param {_Field__Enum_Accountingcategory_Creditor9Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_accountingcategory_creditor9 = /** @type {((inputs?: _Field__Enum_Accountingcategory_Creditor9Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Accountingcategory_Creditor9Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Kreditor")
});
export { _field__enum_accountingcategory_creditor9 as "_field__enum_accountingCategory_CREDITOR" }